<template>
  <div class="ts-border ts-p-3 ts-rounded-md ts-space-y-3 ts-h-full">
    <div>
      <h3
        class="ts-text-lg ts-font-semibold ts-bg-blue-100 ts-px-2 ts-rounded-md ts-py-1 ts-text-blue-500"
        style="width: fit-content;"
      >
        {{ $t('single-copy.copy_to_semester') }}
      </h3>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required">{{ $t('single-copy.scoring_cycle') }}</label>
        <a-select
          v-model="model.scoring_cycle_id"
          show-search
          :filter-option="filterOption"
          :loading="loading"
          :disabled="true"
          style="width: 100%"
          :options="scoringCyleOption"
        ></a-select>
        <div v-if="errors.has('class_id')">
          <span class="text-danger">{{ errors.first('class_id') }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required">{{ $t('single-copy.cycle_value') }}</label>
        <a-select
          v-model="model.cycle_value"
          show-search
          :filter-option="filterOption"
          :placeholder="$t('single-copy.select_cycle_value')"
          :loading="loading"
          :disabled="true"
          style="width: 100%"
          :options="[]"
        ></a-select>
        <div v-if="errors.has('cyle_value')">
          <span class="text-danger">{{ errors.first('cyle_value') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'CopyToTermSemester',
  props: ['value'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      loading: false
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    scoringCyleOption() {
      return [
        {
          value: 2,
          label: 'Semester Score'
        }
      ]
    }
  },
  methods: {
    filterOption(input, option) {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
